import { cva } from 'class-variance-authority';

/**
 * CTA KATMAN SİSTEMİ (PRODUCT-DECISIONS §1.2)
 *
 *  primary   → leaf-900 dolu. Sayfa başına YALNIZCA BİR TANE.
 *  secondary → leaf-700 outline. İkincil aksiyon.
 *  ghost     → leaf-600 metin. Link, "Düzenle".
 *  soft      → leaf-100 zemin. Seçili durum, yumuşak aksiyon.
 *  onImage   → fotoğraf üzerinde. CTA rengi KULLANILMAZ, beyaz cam.
 *
 * Dokunma geri bildirimi (0.97 scale) her varyantta vardır.
 * Bileşenden ayrı dosyada tutulur: link/anchor gibi başka öğeler de aynı
 * görünümü paylaşabilsin diye.
 */
export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center gap-2 whitespace-nowrap',
    'font-medium select-none',
    'transition-[background-color,color,border-color,transform,box-shadow]',
    'duration-fast ease-flow',
    'active:scale-[0.97]',
    'disabled:pointer-events-none disabled:opacity-45',
    'focus-visible:outline-2 focus-visible:outline-offset-2',
  ],
  {
    variants: {
      variant: {
        primary:
          'bg-leaf-900 text-white hover:bg-leaf-800 focus-visible:outline-leaf-900',
        secondary:
          'border border-leaf-700 text-leaf-800 bg-transparent hover:bg-leaf-50',
        ghost: 'text-leaf-600 hover:text-leaf-800 hover:bg-leaf-50',
        soft: 'bg-leaf-100 text-leaf-900 hover:bg-leaf-200',
        onImage: 'bg-white/85 text-ink backdrop-blur-md hover:bg-white shadow-soft',
        quiet: 'text-ink-muted hover:text-ink hover:bg-surface-sunken',
        danger:
          'bg-danger text-white hover:bg-danger/90 focus-visible:outline-danger',
      },
      size: {
        sm: 'h-9 px-3.5 text-sm rounded-sm',
        md: 'h-11 px-5 text-base rounded-sm',
        lg: 'h-13 px-7 text-md rounded-sm',
        /** Mobil yapışkan alt bar: tek elle basılabilir yükseklik */
        thumb: 'h-14 px-6 text-md rounded-sm w-full',
        icon: 'size-10 rounded-sm',
      },
      block: {
        true: 'w-full',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
      block: false,
    },
  },
);
